import { render, staticRenderFns } from "./MdmProfilePage.vue?vue&type=template&id=c9534512&scoped=true&lang=pug&"
import script from "./MdmProfilePage.vue?vue&type=script&lang=js&"
export * from "./MdmProfilePage.vue?vue&type=script&lang=js&"
import style0 from "./MdmProfilePage.vue?vue&type=style&index=0&id=c9534512&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9534512",
  null
  
)

export default component.exports